<template>
  <div>
    <vx-card>
      <ListCarteiraCobranca
        :subjectPermission="subjectPermission"
      ></ListCarteiraCobranca>
    </vx-card>
  </div>
</template>

<script>
import ListCarteiraCobranca from "./../../lists/ListCarteiraCobranca";

export default {
  data() {
    return {
      subjectPermission: "Carteira de Cobrança",
    };
  },
  methods: {},
  components: {
    ListCarteiraCobranca,
  },
};
</script>
